import React, { useEffect, useCallback } from 'react';
import InitialScreen from './components/InitialScreen.jsx';
import MissionScreen from './components/MissionScreen.jsx';
import SolveScreen from './components/SolveScreen.jsx';
import TopBar from './components/TopBar.jsx';
import BottomBar from './components/BottomBar.jsx';
import AlertModal from './components/AlertModal.jsx';
import ToastMessage from './components/ToastMessage.jsx';
import ScanScreen from './components/ScanScreen.jsx';
import LastScannedCardScreen from './components/LastScannedCardScreen.jsx';
import OutcomeScreen from './components/OutcomeScreen.jsx';
import LoadingOverlay from './components/LoadingOverlay.jsx';
import { useGame } from './context/GameContext.jsx';
import './styles.css';

function App() {
  const {
    setLang,
    translations,
    gameStatus,
    alertModalRef,
    alertModalState,
    sessionId,
    isLoading,
    uiTheme
  } = useGame();

  useEffect(() => {
    const storedLang = localStorage.getItem('language');
    if (storedLang && translations[storedLang]) {
      setLang(storedLang);
    }
  }, [setLang, translations]);

  useEffect(() => {
    document.body.className = `ui-theme-${uiTheme}`;
  }, [uiTheme]);

  const renderScreenContent = useCallback(() => {
    switch (gameStatus) {
      case 'mission':
        return <MissionScreen />;
      case 'scan':
        return <ScanScreen />;
      case 'outcome':
      case 'victory':
      case 'gameover':
        return <OutcomeScreen />;
      case 'lastScanned':
        return <LastScannedCardScreen />;
      case 'send':
        return <SolveScreen />;
      case 'initial':
      default:
        return <InitialScreen />;
    }
  }, [gameStatus]);

  const showBars = sessionId !== null && gameStatus !== 'outcome' && gameStatus !== 'victory' && gameStatus !== 'gameover';

  return (
    <>
      {isLoading && <LoadingOverlay />}
      <div className="app-container">
        {showBars && <TopBar />}
        <div className="screen-container">
          {renderScreenContent()}
        </div>
        {showBars && <BottomBar />}
        <AlertModal
          ref={alertModalRef}
          title={alertModalState.title}
          message={alertModalState.message}
          isConfirmation={alertModalState.isConfirmation}
          onConfirm={alertModalState.onConfirm}
          onClose={alertModalState.onClose}
          confirmButtonText={alertModalState.confirmButtonText}
          cancelButtonText={alertModalState.cancelButtonText}
        />
        <ToastMessage />
      </div>
    </>
  );
}

export default App;
